<template lang="pug">
  UiModal(
    v-model="isOpneModal"
    :showFooter="false"
    :destroy="true"
  )
    .questionnaire-modal-content.-center-
      .ui-kit-modal__title.questionnaire-modal-content__title
        | Ты успешно выбрал {{typeName}}!
      Icon.questionnaire-modal-content__img(
        icon="ui-computer-learn"
      )
      UiButton.questionnaire-modal-content__button(
        @click="unshowModal"
      ) Продолжить

</template>

<script>
export default {
  props: {
    value: {}
  },
  data: () => ({
    isOpneModal: false
  }),
  computed: {
    isTriggered() {
      return this.$route.query.set;
    },
    typeName() {
      switch (this.isTriggered) {
        case 'faculty':
          return 'факультет';
        case 'group':
          return 'сборную';
        default:
          return 'данные';
      }
    }
  },
  mounted() {
    this.checkTrigger();
  },
  methods: {
    showModal() {
      this.isOpneModal = true;
    },
    unshowModal() {
      this.isOpneModal = false;
    },
    checkTrigger() {
      if (this.isTriggered) {
        this.showModal();
      }
    }
  }
};
</script>
